import React, {useContext, useEffect, useState} from "react"
import {QuizzContext} from "../context/QuizzContext"
import {useRouter} from "next/router"
import DataContext from "../context/DataContext"
import useCache from "../hooks/useCache"
import {priceRangeDelimiter} from "../components/filter/Config"
import {logger} from "../utility/Helper"
import useFilterRelevantBrands from "../hooks/useFilterRelevantBrands"

type Props = {
    children:React.ReactNode
}
function QuizzContextProvider({children}: Props) {
	const router = useRouter()
	const activeQuizNumber = Number(router.query?.quiz) || 0
	const [activeQuizz, setActiveQuizz] = useState<number>(activeQuizNumber)
	const [quizzData, setQuizzData] = useState<any>({})
	const parseQuizData = quizzData => {
		return Object.entries(quizzData).filter(([key, value]) => !["parentCategories", "subCategories"].includes(key)).map(([key, value]) => {
			const val = value as unknown[] as string[]
			return {[key]: key === "body_height" || key === "priceRange" ? `${val?.[0]?.[0]}${priceRangeDelimiter}${val?.[(val?.length || 0) - 1]?.[1]}` : val?.join(",")}
		}).reduce((acc, newVal) => {
			acc = {...acc, ...newVal}
			return acc
		}, {})
	}

	const {data, isLoading: isLoadingProductsCount} = useCache(`/api/products/product-results-counter?params=${JSON.stringify({...parseQuizData(quizzData || {}), categories: [...(quizzData?.parentCategories || [])?.filter(Boolean), ...(quizzData?.subCategories?.filter(Boolean) || [])].join(",")})}&locale=${router.locale}`)
	const {brandsList, brandsToShow, setBrandsToShow} = useFilterRelevantBrands(quizzData, activeQuizz)
	const {pageProps} = useContext(DataContext)
	const parentCategories = pageProps?.strapiContent?.data?.mega_menus?.filter(cat => ["e_bike", "bike"].includes(cat?.attributes?.slugName))?.map(cat => cat?.attributes)
	const appendQuizAnswers = (answers, quizzName) => {
		setQuizzData(prev => {
			return {
				...prev,
				[quizzName]: [...answers]
			}
		})
	}

	useEffect(() => {
		const quizzDataStoredString = localStorage.getItem("quizzData")
		const quizz = JSON.parse(quizzDataStoredString)
		if (quizz?.activeQuizz > activeQuizz) {
			setQuizzData(() => quizz.quizzData)
			setActiveQuizz(() => quizz.activeQuizz)
		}
	}, [])
	const updateUserQuizzChoices = async () => {
		try {
			localStorage.setItem("quizzData", JSON.stringify({quizzData, activeQuizz}))
		} catch (error) {
			logger.error(error)
		}
	}

	return (
		<QuizzContext.Provider value={{brandsList, brandsToShow, setBrandsToShow, parseQuizData, isLoadingProductsCount, updateUserQuizzChoices, totalNumberOfProducts: data?.totalNumberOfProducts || 0, activeQuizz, appendQuizAnswers, setActiveQuizz, quizzData, parentCategories}}>
			{children}
		</QuizzContext.Provider>
	)
}

export default QuizzContextProvider
